export class GetAllTagsRequest {
    userId : number;
    assignmentId : number;

    constructor() {
        this.userId = 0;
        this.assignmentId = 0;
    }
}